module.exports = __webpack_public_path__ + "static/media/QR_Error.0b8feca5.gif";